module.exports = __webpack_public_path__ + "static/img/point.eace66d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/point.png
// module id = +pR7
// module chunks = 0